
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'payments-ui-app',
  currentProjectVersion: 'static-1.28696',
  depVersions: {
  "payments-ui-app": "static-1.28696",
  "bend-plugin-arboretum": "static-1.2015",
  "apollo-dlb": "static-3.98",
  "client-types": "static-1.510",
  "crm_data": "static-4.93194",
  "data-fetching-client": "static-1.10110",
  "emoji-mart": "static-3.7",
  "enviro": "static-4.455",
  "foundations-components": "static-1.8743",
  "foundations-components-legacy": "static-1.1768",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6063",
  "hs-test-utils": "static-1.8507",
  "hub-http": "static-1.6678",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11959",
  "I18n": "static-7.1706",
  "jasmine-runner": "static-1.6922",
  "quartz": "static-1.7648",
  "raven": "static-3.5925",
  "react-dlb": "static-1.93",
  "react-dnd": "static-2.33",
  "react-dnd-html5-backend": "static-2.10",
  "react-stripe-js": "static-1.120",
  "react-utils": "static-2.5654",
  "reselect": "static-3.16",
  "stripe-js": "static-1.119",
  "ui-components-test-utils": "static-1.6096",
  "UIComponents": "static-3.8905",
  "usage-tracker-public": "static-1.7604",
  "apollo-stack-hubspot": "static-3.94",
  "commerce-subscription-lib": "static-1.38044",
  "payments-checkout-lib": "static-1.619",
  "cssUtils": "static-1.1094",
  "customer-data-objects": "static-1.8172",
  "FireAlarmUi": "static-1.4858",
  "foundations-assets": "static-1.5356",
  "foundations-theming": "static-1.4959",
  "graphql": "static-1.93",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12266",
  "icons": "static-2.702",
  "isMobile": "static-1.7",
  "metrics-js": "static-1.9990",
  "PatternValidationJS": "static-1.3356",
  "property-translator": "static-1.5850",
  "quartz-config": "static-1.1426",
  "quartz-core": "static-1.6867",
  "quartz-i18n": "static-1.1323",
  "quartz-routing": "static-1.1078",
  "quartz-tracking": "static-1.1027",
  "react": "static-7.202",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17204",
  "react-select-plus": "static-1.118",
  "react-virtualized": "static-2.112",
  "redux": "static-4.81",
  "redux-thunk": "static-2.84",
  "redux-toolkit": "static-1.82",
  "ReduxMessenger": "static-2.10840",
  "rpc-client-utils": "static-1.5141",
  "sanitize-text": "static-1.8629",
  "SharedI18nStrings": "static-1.187",
  "styled-components": "static-2.100",
  "StyleGuideUI": "static-3.518",
  "superstore": "static-1.5229",
  "transmute": "static-2.97",
  "ui-addon-i18n": "static-1.11618",
  "ui-images": "static-2.1276",
  "usage-tracker-core": "static-1.7643",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3925",
  "quartz-webpack": "static-1.3872",
  "bend-plugin-quartz-routing": "static-1.726",
  "bender-build-tools": "static-1.3567",
  "crm_universal": "static-1.22718",
  "customer-data-email": "static-1.18632",
  "customer-data-ui-utilities": "static-1.10306",
  "dispatcher": "static-1.147",
  "frontend-preferences-client": "static-1.8391",
  "general-store": "static-6.20",
  "native-integrations-shared-strings": "static-1.8233",
  "quick-fetch": "static-1.4229",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.5012",
  "floating-ui": "static-1.68",
  "foundations-theming-specialty": "static-1.2675",
  "framer-motion": "static-1.84",
  "hs-story-utils": "static-1.9894",
  "react-aria": "static-1.77",
  "react-create-root-preference": "static-1.101",
  "tanstack-table": "static-1.66",
  "trellis-assets": "static-1.3070",
  "ui-fonts": "static-1.1221",
  "HeadJS": "static-2.820",
  "hs-test-utils-bend-plugin": "static-1.3618",
  "msw": "static-1.102",
  "msw-config": "static-1.27",
  "testing-library": "static-1.164",
  "hs-locale-management": "static-1.398",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.234",
  "moment-timezone": "static-5.96",
  "jasmine": "static-4.4780",
  "foundations-components-test-utils": "static-1.6226",
  "ui-addon-draggable": "static-3.5220",
  "commerce-billing-lib": "static-1.20481",
  "commerce-shared-components-lib": "static-1.19557",
  "commerce-tools-ui-lib": "static-1.11314",
  "crm-message-bus": "static-1.44092",
  "customer-data-objects-ui-components": "static-1.13505",
  "customer-data-properties": "static-1.53019",
  "growth-payments-core": "static-1.26493",
  "ui-addon-iframeable": "static-1.9545",
  "usage-tracker": "static-1.7793",
  "usage-tracker-container": "static-1.7783",
  "sassPrefix": "static-1.359",
  "inbound-db-properties-service-client": "static-1.4150",
  "foundations-theming-base": "static-1.3944",
  "bend-plugin-foundations-theming": "static-1.3442",
  "stylex": "static-1.46",
  "opentelemetry-fe-types": "static-1.262",
  "hub-http-janus": "static-1.905",
  "hubspotter-http": "static-1.4973",
  "mobile-manifest-mixins": "static-1.604",
  "module-federation": "static-1.38",
  "opentelemetry-fe": "static-1.637",
  "quartz-auth": "static-1.1323",
  "quartz-head": "static-1.1313",
  "quartz-test": "static-1.1323",
  "trellis-components": "static-1.3089",
  "usage-tracker-session-replay": "static-1.5479",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.171",
  "web-vitals": "static-1.19",
  "immer": "static-1.105",
  "bend-plugin-chirp-manifest": "static-1.551",
  "chirp-fetch": "static-1.2374",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4944",
  "FormUrlGenerator": "static-2.5186",
  "sequences-lib": "static-1.8764",
  "apollo-link-hub-http": "static-2.5058",
  "FileManagerCore": "static-1.40327",
  "FileManagerLib": "static-1.40468",
  "hubspot-apollo-client": "static-1.5351",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "salesImages": "static-1.728",
  "timezone-utils": "static-2.5702",
  "ui-gdpr-components": "static-1.10655",
  "react-dnd-compat": "static-1.5082",
  "stylex-utils": "static-1.173",
  "trellis-theming": "static-1.1470",
  "react-flip-move": "static-1.83",
  "avatar-components": "static-1.2957",
  "hs-resources": "static-1.664",
  "pulse": "static-1.1117",
  "utility-belt": "static-1.3007",
  "zustand": "static-1.89",
  "batch-promise": "static-1.2017",
  "customer-data-associations": "static-1.7810",
  "customer-data-property-utils": "static-1.8521",
  "customer-data-tracking": "static-1.7340",
  "framework-data-schema-resolvers": "static-1.7363",
  "framework-data-table": "static-2.12831",
  "object-builder-ui-client": "static-1.50035",
  "payments-enrollment-embed-lib": "static-1.24184",
  "stripe-embedded-components": "static-1.8237",
  "ui-addon-opt": "static-4.8873",
  "ai-components-ui-library": "static-1.10010",
  "customer-data-rte": "static-1.33894",
  "cv-backend-services": "static-1.1607",
  "file-manager-components": "static-1.24828",
  "growth-onboarding-confetti": "static-1.3531",
  "growth-onboarding-empty-states": "static-1.6525",
  "hubspot-prosemirror": "static-1.19271",
  "InboxConnectUtils": "static-4.15836",
  "payment-link-components": "static-1.24448",
  "payments-post-enroll-local-storage-lib": "static-1.5575",
  "prosemirror": "static-1.13",
  "qrcode-generator": "static-1.80",
  "quotes-client-types": "static-1.39161",
  "react-colorpicker": "static-2.10680",
  "ui-addon-upgrades": "static-9.18547",
  "ui-addon-video-player": "static-1.9093",
  "user-context": "static-1.5524",
  "restore-request-side-panel-lib": "static-1.2023",
  "atom": "static-1.5543",
  "reference-resolvers": "static-1.8652",
  "calling-global-api": "static-1.66173",
  "calling-internal-common": "static-1.31796",
  "calling-lifecycle-internal": "static-1.67555",
  "calling-lifecycle-messages": "static-1.59848",
  "commerce-products-lib": "static-1.10899",
  "conditional-properties-service-client": "static-1.4111",
  "crm-index-visualization-core": "static-1.4751",
  "crm-links": "static-1.6780",
  "crm-pipelines-api-client-types": "static-1.4441",
  "customer-data-properties-shared-msw-handlers": "static-1.10220",
  "external-options-client-types": "static-1.4438",
  "formula-editor": "static-1.15005",
  "google-libphonenumber": "static-1.49",
  "inbound-db-meta-service-client": "static-1.3773",
  "inbounddb-objects-service-types": "static-1.4518",
  "meetings-icalendar-utils-lib": "static-1.1105",
  "multi-currency-client-types": "static-1.4006",
  "pipeline-validation-client-types": "static-1.4279",
  "property-value-citations": "static-1.3633",
  "reference-resolvers-lite": "static-1.8580",
  "smart-data-capture-core": "static-1.464",
  "smart-property-lib": "static-1.8644",
  "tiered-pricing": "static-1.2258",
  "topics-actions-lib": "static-1.655",
  "trellis-ext-i18n": "static-1.1380",
  "trial-components-library": "static-1.14368",
  "ui-addon-form-validation": "static-1.11346",
  "laboratory-lib": "static-3.7618",
  "onboarding-scopes": "static-1.6923",
  "seat-types-lib": "static-1.1043",
  "magpie-lib": "static-1.5904",
  "navigation-messaging": "static-1.8487",
  "ts-schema": "static-1.4391",
  "opentelemetry-web": "static-1.22",
  "hub-http-shared-msw-handlers": "static-1.10893",
  "hubspotter-http-shared-msw-handlers": "static-1.10891",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.15",
  "tanstack-virtual": "static-1.43",
  "amplitude-session-replay-browser": "static-1.60",
  "sequences-client-types-lib": "static-1.8621",
  "audio-components": "static-1.6562",
  "breeze-artifacts-sdk": "static-1.926",
  "ContentUtils": "static-1.69460",
  "copilot-toolkit": "static-1.12137",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30054",
  "FileManagerImages": "static-1.37979",
  "html-to-image": "static-1.65",
  "immerable": "static-1.4613",
  "ui-universal-auth": "static-1.9730",
  "urlinator": "static-1.4986",
  "video-components": "static-1.14423",
  "video-data-lib": "static-1.36079",
  "video-embed": "static-1.36913",
  "hubspot-apollo-cache": "static-1.810",
  "trellis-migration-context": "static-1.49",
  "event-emitter": "static-1.1433",
  "fdsr-migration-layer": "static-1.482",
  "framework-builder-read-service-client": "static-1.4333",
  "bend-plugin-pulse": "static-1.620",
  "fast-json-patch": "static-1.74",
  "framework-data-schema-quick-fetch": "static-1.7268",
  "persist-promise": "static-1.4174",
  "customer-data-reference-ui-components": "static-1.13644",
  "reporting-data": "static-1.69333",
  "tasks-actions-lib": "static-1.425",
  "purchase-motions-components": "static-1.6622",
  "growth-onboarding-feedback-components": "static-1.7054",
  "growth-onboarding-reliability": "static-1.5553",
  "marketplace-ui-apps-core": "static-1.19573",
  "onboarding-tours": "static-1.17393",
  "stripe-connect-js": "static-1.82",
  "chatspot-core": "static-1.23844",
  "content-assistance-lib": "static-1.8415",
  "draft-content-plugins": "static-1.29147",
  "draft-convert": "static-2.84",
  "draft-extend": "static-3.88",
  "draft-js": "static-5.90",
  "draft-plugins": "static-2.22351",
  "rich-text-lib": "static-1.20545",
  "breeze-engine-lib": "static-1.2147",
  "poll-commands": "static-1.3947",
  "video-components-external": "static-1.12421",
  "trellis-story-utils": "static-1.4970",
  "ui-addon-react-router-dom": "static-1.9998",
  "content-media-capture": "static-1.5779",
  "knowledge-content-types": "static-1.8759",
  "ui-addon-emoji-picker": "static-1.10333",
  "ui-business-units-lib": "static-1.9568",
  "ui-shepherd-react": "static-3.10748",
  "hub-http-contrib": "static-1.3501",
  "ui-addon-sales-email": "static-1.5673",
  "commerce-tours-lib": "static-1.6856",
  "getting-started-shared-tasks": "static-1.19553",
  "sales-checkout-service-client": "static-1.3994",
  "merchandise-lib": "static-1.284",
  "getting-started-shared-tasks-store": "static-1.18671",
  "onboarding-tours-utils": "static-1.1460",
  "calling-error-reporting": "static-1.31803",
  "shared-worker-versioning": "static-1.11511",
  "calling-usage-tracker": "static-1.7008",
  "conversations-skeleton-state": "static-1.7607",
  "voice-sms-access-library": "static-1.2427",
  "commerce-permissions": "static-1.1257",
  "products-iframe-lib": "static-1.8899",
  "products-ui-components-shared-msw-handlers": "static-1.11275",
  "crm-index-associations-lib": "static-1.6921",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10976",
  "sales-views-client-types": "static-1.4726",
  "location-customization-utils-lib": "static-1.10409",
  "bark-lib": "static-1.17002",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.106",
  "crm-properties-common-lib": "static-1.6364",
  "react-codemirror": "static-1.11111",
  "data-agent-kit": "static-1.907",
  "data-agent-test-utils": "static-1.451",
  "data-agent-utils": "static-1.920",
  "data-token-picker": "static-1.17126",
  "fsm": "static-1.4230",
  "markdown-it": "static-1.6",
  "policy-lib": "static-1.7281",
  "react-tinymce": "static-1.56262",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.11039",
  "tinymce-config": "static-2.55388",
  "tinymce-plugins": "static-1.58502",
  "embedded-academy-lib": "static-1.15994",
  "hubs-service-types": "static-1.1737",
  "navigation-components": "static-1.19160",
  "nest": "static-1.706",
  "nudge-client-utils": "static-1.3412",
  "purchase-motions-api": "static-1.6625",
  "signup-constants": "static-1.19934",
  "idb-keyval": "static-1.55",
  "magpie-types": "static-1.5364",
  "reactive-lib": "static-1.1191",
  "simple-logging-lib": "static-1.3522",
  "nav-meta": "static-1.30797",
  "breeze-engine-core": "static-1.1425",
  "cms-field-types": "static-1.5282",
  "content-icons-ui": "static-1.2453",
  "integrations-lib": "static-1.17420",
  "underscore": "static-1.8",
  "custom-vendor-connection-lib": "static-1.294",
  "unified-auth-core-lib": "static-1.1526",
  "social-insights-client-types": "static-1.22920",
  "outpost": "static-1.4600",
  "reporting-client-types": "static-1.2830",
  "signup-ui-url-generator": "static-2.8520",
  "developer-experience-shared-components": "static-1.11009",
  "immutable-less": "static-1.5124",
  "marketplace-ui-client-types": "static-1.18448",
  "marketplace-ui-common": "static-1.21041",
  "ui-addon-integrations-directory-panel": "static-2.8424",
  "ui-extensibility-client-types": "static-1.4387",
  "growth-data-modal": "static-1.6128",
  "growth-onboarding-next-action-utils": "static-1.2974",
  "onboarding-tours-client": "static-1.5608",
  "ui-shepherd-tracker": "static-1.8129",
  "ui-coaching-tips": "static-1.29579",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1125",
  "highlight.js": "static-1.90",
  "content-media-composition-data-lib": "static-1.13583",
  "content-media-compositions": "static-2.17590",
  "media-bridge-lib": "static-1.19633",
  "fix-webm-duration": "static-1.34",
  "notification-sounds": "static-1.4898",
  "calling-orchestration-schema": "static-1.37204",
  "crm-record-cards-service-types": "static-1.3871",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16660",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.115",
  "enrichment-settings-lib": "static-1.226",
  "storybook-react": "static-1.44",
  "tinymce": "static-5.11",
  "tinymce-themes": "static-1.57358",
  "interframe": "static-3.5211",
  "tinymce-data": "static-1.41473",
  "layout-dnd-components": "static-1.13219",
  "layout-dnd-utils": "static-1.12194",
  "ui-brand-identity-lib": "static-1.16932",
  "academy-common-lib": "static-1.15455",
  "nudge-custom-function-registry": "static-1.3169",
  "nudge-renderer-utils": "static-1.3488",
  "whisper-core-api": "static-1.7625",
  "flux-actions": "static-1.380",
  "integrations-error-boundary-lib": "static-1.14835",
  "integrations-tracking-lib": "static-1.6090",
  "redux-observable": "static-1.79",
  "rxjs": "static-5.10",
  "apps-service-types": "static-1.4096",
  "oauth-service-types": "static-1.4607",
  "ai-settings-ui-library": "static-1.8576",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1569",
  "onboarding-data-sync-lib": "static-1.2834",
  "growth-onboarding-next-action-components": "static-1.3002",
  "user-context-client": "static-1.4981",
  "js-cookie": "static-1.18",
  "NamespacedHubStyle": "static-2.9365",
  "ContentData": "static-1.69535",
  "layout-data-lib": "static-1.10519",
  "academy-service-client": "static-1.4162",
  "croppie": "static-2.10",
  "final-form": "static-1.83",
  "SafeStorage": "static-1.4866",
  "trellis-ecosystem": "static-1.7843",
  "wootric-nps": "static-1.7295",
  "universal-page-editor-lib": "static-1.3481",
  "settings-ui-lib": "static-1.12999",
  "simple-data-table": "static-1.3810",
  "meetings-connect-utils-lib": "static-1.8088",
  "advanced-menus-core": "static-1.15809",
  "advanced-menus-lib": "static-1.12565",
  "ExportDialog": "static-6.10842",
  "ui-memberships-settings-lib": "static-1.35176",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15808",
  "simple-menus-lib": "static-1.17325"
},
  depPathPrefixes: {
  "payments-ui-app": "/payments-ui-app/static-1.28696",
  "bend-plugin-arboretum": "/bend-plugin-arboretum/static-1.2015",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "client-types": "/client-types/static-1.510",
  "crm_data": "/crm_data/static-4.93194",
  "data-fetching-client": "/data-fetching-client/static-1.10110",
  "emoji-mart": "/emoji-mart/static-3.7",
  "enviro": "/enviro/static-4.455",
  "foundations-components": "/foundations-components/static-1.8743",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1768",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6063",
  "hs-test-utils": "/hs-test-utils/static-1.8507",
  "hub-http": "/hub-http/static-1.6678",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11959",
  "I18n": "/I18n/static-7.1706",
  "jasmine-runner": "/jasmine-runner/static-1.6922",
  "quartz": "/quartz/static-1.7648",
  "raven": "/raven/static-3.5925",
  "react-dlb": "/react-dlb/static-1.93",
  "react-dnd": "/react-dnd/static-2.33",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "react-stripe-js": "/react-stripe-js/static-1.120",
  "react-utils": "/react-utils/static-2.5654",
  "reselect": "/reselect/static-3.16",
  "stripe-js": "/stripe-js/static-1.119",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6096",
  "UIComponents": "/UIComponents/static-3.8905",
  "usage-tracker-public": "/usage-tracker-public/static-1.7604",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38044",
  "payments-checkout-lib": "/payments-checkout-lib/static-1.619",
  "cssUtils": "/cssUtils/static-1.1094",
  "customer-data-objects": "/customer-data-objects/static-1.8172",
  "FireAlarmUi": "/FireAlarmUi/static-1.4858",
  "foundations-assets": "/foundations-assets/static-1.5356",
  "foundations-theming": "/foundations-theming/static-1.4959",
  "graphql": "/graphql/static-1.93",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12266",
  "icons": "/icons/static-2.702",
  "isMobile": "/isMobile/static-1.7",
  "metrics-js": "/metrics-js/static-1.9990",
  "PatternValidationJS": "/PatternValidationJS/static-1.3356",
  "property-translator": "/property-translator/static-1.5850",
  "quartz-config": "/quartz-config/static-1.1426",
  "quartz-core": "/quartz-core/static-1.6867",
  "quartz-i18n": "/quartz-i18n/static-1.1323",
  "quartz-routing": "/quartz-routing/static-1.1078",
  "quartz-tracking": "/quartz-tracking/static-1.1027",
  "react": "/react/static-7.202",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17204",
  "react-select-plus": "/react-select-plus/static-1.118",
  "react-virtualized": "/react-virtualized/static-2.112",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.84",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "ReduxMessenger": "/ReduxMessenger/static-2.10840",
  "rpc-client-utils": "/rpc-client-utils/static-1.5141",
  "sanitize-text": "/sanitize-text/static-1.8629",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.187",
  "styled-components": "/styled-components/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.518",
  "superstore": "/superstore/static-1.5229",
  "transmute": "/transmute/static-2.97",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11618",
  "ui-images": "/ui-images/static-2.1276",
  "usage-tracker-core": "/usage-tracker-core/static-1.7643",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3925",
  "quartz-webpack": "/quartz-webpack/static-1.3872",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.726",
  "bender-build-tools": "/bender-build-tools/static-1.3567",
  "crm_universal": "/crm_universal/static-1.22718",
  "customer-data-email": "/customer-data-email/static-1.18632",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10306",
  "dispatcher": "/dispatcher/static-1.147",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8391",
  "general-store": "/general-store/static-6.20",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8233",
  "quick-fetch": "/quick-fetch/static-1.4229",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5012",
  "floating-ui": "/floating-ui/static-1.68",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2675",
  "framer-motion": "/framer-motion/static-1.84",
  "hs-story-utils": "/hs-story-utils/static-1.9894",
  "react-aria": "/react-aria/static-1.77",
  "react-create-root-preference": "/react-create-root-preference/static-1.101",
  "tanstack-table": "/tanstack-table/static-1.66",
  "trellis-assets": "/trellis-assets/static-1.3070",
  "ui-fonts": "/ui-fonts/static-1.1221",
  "HeadJS": "/HeadJS/static-2.820",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3618",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.27",
  "testing-library": "/testing-library/static-1.164",
  "hs-locale-management": "/hs-locale-management/static-1.398",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.234",
  "moment-timezone": "/moment-timezone/static-5.96",
  "jasmine": "/jasmine/static-4.4780",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6226",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5220",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20481",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19557",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11314",
  "crm-message-bus": "/crm-message-bus/static-1.44092",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13505",
  "customer-data-properties": "/customer-data-properties/static-1.53019",
  "growth-payments-core": "/growth-payments-core/static-1.26493",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9545",
  "usage-tracker": "/usage-tracker/static-1.7793",
  "usage-tracker-container": "/usage-tracker-container/static-1.7783",
  "sassPrefix": "/sassPrefix/static-1.359",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4150",
  "foundations-theming-base": "/foundations-theming-base/static-1.3944",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3442",
  "stylex": "/stylex/static-1.46",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.262",
  "hub-http-janus": "/hub-http-janus/static-1.905",
  "hubspotter-http": "/hubspotter-http/static-1.4973",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.604",
  "module-federation": "/module-federation/static-1.38",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.637",
  "quartz-auth": "/quartz-auth/static-1.1323",
  "quartz-head": "/quartz-head/static-1.1313",
  "quartz-test": "/quartz-test/static-1.1323",
  "trellis-components": "/trellis-components/static-1.3089",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5479",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.171",
  "web-vitals": "/web-vitals/static-1.19",
  "immer": "/immer/static-1.105",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.551",
  "chirp-fetch": "/chirp-fetch/static-1.2374",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4944",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5186",
  "sequences-lib": "/sequences-lib/static-1.8764",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5058",
  "FileManagerCore": "/FileManagerCore/static-1.40327",
  "FileManagerLib": "/FileManagerLib/static-1.40468",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5351",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "salesImages": "/salesImages/static-1.728",
  "timezone-utils": "/timezone-utils/static-2.5702",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10655",
  "react-dnd-compat": "/react-dnd-compat/static-1.5082",
  "stylex-utils": "/stylex-utils/static-1.173",
  "trellis-theming": "/trellis-theming/static-1.1470",
  "react-flip-move": "/react-flip-move/static-1.83",
  "avatar-components": "/avatar-components/static-1.2957",
  "hs-resources": "/hs-resources/static-1.664",
  "pulse": "/pulse/static-1.1117",
  "utility-belt": "/utility-belt/static-1.3007",
  "zustand": "/zustand/static-1.89",
  "batch-promise": "/batch-promise/static-1.2017",
  "customer-data-associations": "/customer-data-associations/static-1.7810",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8521",
  "customer-data-tracking": "/customer-data-tracking/static-1.7340",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7363",
  "framework-data-table": "/framework-data-table/static-2.12831",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50035",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24184",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8237",
  "ui-addon-opt": "/ui-addon-opt/static-4.8873",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10010",
  "customer-data-rte": "/customer-data-rte/static-1.33894",
  "cv-backend-services": "/cv-backend-services/static-1.1607",
  "file-manager-components": "/file-manager-components/static-1.24828",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3531",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6525",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19271",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15836",
  "payment-link-components": "/payment-link-components/static-1.24448",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5575",
  "prosemirror": "/prosemirror/static-1.13",
  "qrcode-generator": "/qrcode-generator/static-1.80",
  "quotes-client-types": "/quotes-client-types/static-1.39161",
  "react-colorpicker": "/react-colorpicker/static-2.10680",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18547",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9093",
  "user-context": "/user-context/static-1.5524",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2023",
  "atom": "/atom/static-1.5543",
  "reference-resolvers": "/reference-resolvers/static-1.8652",
  "calling-global-api": "/calling-global-api/static-1.66173",
  "calling-internal-common": "/calling-internal-common/static-1.31796",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67555",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59848",
  "commerce-products-lib": "/commerce-products-lib/static-1.10899",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4111",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4751",
  "crm-links": "/crm-links/static-1.6780",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4441",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10220",
  "external-options-client-types": "/external-options-client-types/static-1.4438",
  "formula-editor": "/formula-editor/static-1.15005",
  "google-libphonenumber": "/google-libphonenumber/static-1.49",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3773",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4518",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1105",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4006",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4279",
  "property-value-citations": "/property-value-citations/static-1.3633",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8580",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.464",
  "smart-property-lib": "/smart-property-lib/static-1.8644",
  "tiered-pricing": "/tiered-pricing/static-1.2258",
  "topics-actions-lib": "/topics-actions-lib/static-1.655",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1380",
  "trial-components-library": "/trial-components-library/static-1.14368",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11346",
  "laboratory-lib": "/laboratory-lib/static-3.7618",
  "onboarding-scopes": "/onboarding-scopes/static-1.6923",
  "seat-types-lib": "/seat-types-lib/static-1.1043",
  "magpie-lib": "/magpie-lib/static-1.5904",
  "navigation-messaging": "/navigation-messaging/static-1.8487",
  "ts-schema": "/ts-schema/static-1.4391",
  "opentelemetry-web": "/opentelemetry-web/static-1.22",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10893",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10891",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.15",
  "tanstack-virtual": "/tanstack-virtual/static-1.43",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8621",
  "audio-components": "/audio-components/static-1.6562",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.926",
  "ContentUtils": "/ContentUtils/static-1.69460",
  "copilot-toolkit": "/copilot-toolkit/static-1.12137",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30054",
  "FileManagerImages": "/FileManagerImages/static-1.37979",
  "html-to-image": "/html-to-image/static-1.65",
  "immerable": "/immerable/static-1.4613",
  "ui-universal-auth": "/ui-universal-auth/static-1.9730",
  "urlinator": "/urlinator/static-1.4986",
  "video-components": "/video-components/static-1.14423",
  "video-data-lib": "/video-data-lib/static-1.36079",
  "video-embed": "/video-embed/static-1.36913",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.810",
  "trellis-migration-context": "/trellis-migration-context/static-1.49",
  "event-emitter": "/event-emitter/static-1.1433",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.482",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4333",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.620",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7268",
  "persist-promise": "/persist-promise/static-1.4174",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13644",
  "reporting-data": "/reporting-data/static-1.69333",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.425",
  "purchase-motions-components": "/purchase-motions-components/static-1.6622",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7054",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5553",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19573",
  "onboarding-tours": "/onboarding-tours/static-1.17393",
  "stripe-connect-js": "/stripe-connect-js/static-1.82",
  "chatspot-core": "/chatspot-core/static-1.23844",
  "content-assistance-lib": "/content-assistance-lib/static-1.8415",
  "draft-content-plugins": "/draft-content-plugins/static-1.29147",
  "draft-convert": "/draft-convert/static-2.84",
  "draft-extend": "/draft-extend/static-3.88",
  "draft-js": "/draft-js/static-5.90",
  "draft-plugins": "/draft-plugins/static-2.22351",
  "rich-text-lib": "/rich-text-lib/static-1.20545",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2147",
  "poll-commands": "/poll-commands/static-1.3947",
  "video-components-external": "/video-components-external/static-1.12421",
  "trellis-story-utils": "/trellis-story-utils/static-1.4970",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9998",
  "content-media-capture": "/content-media-capture/static-1.5779",
  "knowledge-content-types": "/knowledge-content-types/static-1.8759",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10333",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9568",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10748",
  "hub-http-contrib": "/hub-http-contrib/static-1.3501",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5673",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6856",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19553",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3994",
  "merchandise-lib": "/merchandise-lib/static-1.284",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18671",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1460",
  "calling-error-reporting": "/calling-error-reporting/static-1.31803",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11511",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7008",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7607",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2427",
  "commerce-permissions": "/commerce-permissions/static-1.1257",
  "products-iframe-lib": "/products-iframe-lib/static-1.8899",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11275",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6921",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10976",
  "sales-views-client-types": "/sales-views-client-types/static-1.4726",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10409",
  "bark-lib": "/bark-lib/static-1.17002",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.106",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6364",
  "react-codemirror": "/react-codemirror/static-1.11111",
  "data-agent-kit": "/data-agent-kit/static-1.907",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.451",
  "data-agent-utils": "/data-agent-utils/static-1.920",
  "data-token-picker": "/data-token-picker/static-1.17126",
  "fsm": "/fsm/static-1.4230",
  "markdown-it": "/markdown-it/static-1.6",
  "policy-lib": "/policy-lib/static-1.7281",
  "react-tinymce": "/react-tinymce/static-1.56262",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.11039",
  "tinymce-config": "/tinymce-config/static-2.55388",
  "tinymce-plugins": "/tinymce-plugins/static-1.58502",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15994",
  "hubs-service-types": "/hubs-service-types/static-1.1737",
  "navigation-components": "/navigation-components/static-1.19160",
  "nest": "/nest/static-1.706",
  "nudge-client-utils": "/nudge-client-utils/static-1.3412",
  "purchase-motions-api": "/purchase-motions-api/static-1.6625",
  "signup-constants": "/signup-constants/static-1.19934",
  "idb-keyval": "/idb-keyval/static-1.55",
  "magpie-types": "/magpie-types/static-1.5364",
  "reactive-lib": "/reactive-lib/static-1.1191",
  "simple-logging-lib": "/simple-logging-lib/static-1.3522",
  "nav-meta": "/nav-meta/static-1.30797",
  "breeze-engine-core": "/breeze-engine-core/static-1.1425",
  "cms-field-types": "/cms-field-types/static-1.5282",
  "content-icons-ui": "/content-icons-ui/static-1.2453",
  "integrations-lib": "/integrations-lib/static-1.17420",
  "underscore": "/underscore/static-1.8",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.294",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1526",
  "social-insights-client-types": "/social-insights-client-types/static-1.22920",
  "outpost": "/outpost/static-1.4600",
  "reporting-client-types": "/reporting-client-types/static-1.2830",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8520",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11009",
  "immutable-less": "/immutable-less/static-1.5124",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18448",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21041",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8424",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4387",
  "growth-data-modal": "/growth-data-modal/static-1.6128",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2974",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5608",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8129",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29579",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1125",
  "highlight.js": "/highlight.js/static-1.90",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13583",
  "content-media-compositions": "/content-media-compositions/static-2.17590",
  "media-bridge-lib": "/media-bridge-lib/static-1.19633",
  "fix-webm-duration": "/fix-webm-duration/static-1.34",
  "notification-sounds": "/notification-sounds/static-1.4898",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37204",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3871",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16660",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.115",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.226",
  "storybook-react": "/storybook-react/static-1.44",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-themes": "/tinymce-themes/static-1.57358",
  "interframe": "/interframe/static-3.5211",
  "tinymce-data": "/tinymce-data/static-1.41473",
  "layout-dnd-components": "/layout-dnd-components/static-1.13219",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12194",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16932",
  "academy-common-lib": "/academy-common-lib/static-1.15455",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3169",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3488",
  "whisper-core-api": "/whisper-core-api/static-1.7625",
  "flux-actions": "/flux-actions/static-1.380",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14835",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6090",
  "redux-observable": "/redux-observable/static-1.79",
  "rxjs": "/rxjs/static-5.10",
  "apps-service-types": "/apps-service-types/static-1.4096",
  "oauth-service-types": "/oauth-service-types/static-1.4607",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8576",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1569",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2834",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3002",
  "user-context-client": "/user-context-client/static-1.4981",
  "js-cookie": "/js-cookie/static-1.18",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9365",
  "ContentData": "/ContentData/static-1.69535",
  "layout-data-lib": "/layout-data-lib/static-1.10519",
  "academy-service-client": "/academy-service-client/static-1.4162",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.83",
  "SafeStorage": "/SafeStorage/static-1.4866",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7843",
  "wootric-nps": "/wootric-nps/static-1.7295",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3481",
  "settings-ui-lib": "/settings-ui-lib/static-1.12999",
  "simple-data-table": "/simple-data-table/static-1.3810",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8088",
  "advanced-menus-core": "/advanced-menus-core/static-1.15809",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12565",
  "ExportDialog": "/ExportDialog/static-6.10842",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35176",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15808",
  "simple-menus-lib": "/simple-menus-lib/static-1.17325"
}
};
